import React from 'react'
import PropTypes from 'prop-types'
import { Spinner } from '../Spinner'
import './LoadingOverlay.module.scss'

const propTypes = {
  /**
   * If true, shows overlay
   */
  loading: PropTypes.string,
  /**
   * Children that will be overlayed
   */
  children: PropTypes.node,
}

/**
 * When loading, show overlay over wrapped component
 */
function LoadingOverlay(props) {
  const { loading = false, children = null } = props ?? {}

  return (
    <div className="Uic-LoadingOverlay-overlayWrapper">
      {loading && (
        <>
          <div className="Uic-LoadingOverlay-overlay" />
          <div className="Uic-LoadingOverlay-spinnerWrapper">
            <Spinner className="Uic-LoadingOverlay-overlaySpinner" />
          </div>
        </>
      )}
      {children}
    </div>
  )
}

LoadingOverlay.propTypes = propTypes

export default LoadingOverlay
